// src/components/ContactMeSection.js
// Static site (Cloudflare Pages): no form backend, plain links only.
import React from "react";
import { EMAIL, GITHUB_URL, LINKEDIN_URL } from "./links";

const ContactMeSection = () => (
  <section className="contact" id="contact">
    <h2>Let's build something.</h2>
    <p>{EMAIL}</p>
    <div className="cta">
      <a className="btn p" href={`mailto:${EMAIL}`}>
        Email me
      </a>
      <a className="btn" href={GITHUB_URL} target="_blank" rel="noopener noreferrer">
        GitHub
      </a>
      <a className="btn" href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer">
        LinkedIn
      </a>
    </div>
  </section>
);

export default ContactMeSection;
